import { AuthGuardService } from '../auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EvaluationDetailsComponent } from './evaluation-details/evaluation-details.component';
import { ShortFallComponent } from './shortfall/shortfall.component';
import { EvaluationTrackingSearchComponent } from '../compensation/evaluation-tracking/evaluation-tracking.component';

const routes: Routes = [
  {
    path: 'search-contest-and-incentive',
    component: EvaluationTrackingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'contest-and-incentive-details/:id',
    component: ShortFallComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'contest-and-incentive-details-drilldown/:id',
    component: EvaluationDetailsComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContestAndIncentiveDetailsRoutingModule {}
